import {Button} from '@mui/material'
import {styled} from '@mui/material/styles'

export const CopyToClipboardDiv = styled('div')(() => ({
  float: 'right'
}))

export const StyledCopyEmailButton = styled(Button)(({theme}) => ({
  color: theme.palette.common.white,
  borderRadius: '15px',
  border: `1px solid ${theme.palette.common.white}`,
  textTransform: 'none',
  ':hover': {
    border: `1px solid ${theme.palette.common.white}`
  },
  marginRight: '5px'
}))
